import { type languages } from "@/i18n/settings";
import { type Locale } from "@/types";
import { getPathSliceFromIndex } from "../url/getPathSliceFromIndex";

export function getLocaleFromPath(
  path: string,
  locales: typeof languages,
  lookupFromPathIndex: number,
) {
  const segments = getPathSliceFromIndex(path, 0).split("/");

  return [...locales, "cimode"].includes(segments[lookupFromPathIndex])
    ? (segments[lookupFromPathIndex] as Locale)
    : ("" as Locale);
}
